export const environment = {
  production: true,
  sentry_env: 'staging',
  env: 'staging',
  version: '5.0.2',
  logging: 'info', // debug, info, warn, error
  UPLOAD_API_KEY: 'qwVgXVw04najpYp7UHPqEaxxWFYckFV8aUAXYXgw',
  API_URL: 'https://staging.fdm.api.treesoflives.com',
  APP_URL: 'https://staging.fdm.treesoflives.com',
  RESTRICTED_BUCKET: 'treesoflives-field-data-infra-staging-restricted-docs',
  AWS_REGION: 'us-east-1',
  API_SERVICE: 'execute-api',
  IDENTITY_POOL_ID: 'us-east-1:5466f0e2-c1db-4ec4-a9c7-696e478872b6',
  USER_POOL_ID: 'us-east-1_B6ocl5b61',
  USER_POOL_WEB_CLIENT_ID: '1hf729uavdej15g0qto7maovmq',
  API_NAME: 'fdm-api',
  SENTRY_DSN: 'https://6038cbf0eb2349ea96f086fc05853508@o490175.ingest.sentry.io/5735270',
  BUCKET_AVATARS: 'treesoflives-field-data-infra-staging-uploads-public',
  BUCKET_MEDIABUNDLES: 'treesoflives-field-data-infra-staging-uploads',
  BUCKET_MEDIABUNDLES_THUMBNAILS: 'treesoflives-field-data-infra-staging-uploads-public',
  BUCKET_DYNAMICFORM_THUMBNAILS: 'treesoflives-field-data-infra-staging-uploads-public',
  GOOGLE_API_KEY: 'AIzaSyB0yVfcIffKZ1zIOzJ0zRcyJC2F4c0VdSM',
  origin: 'https://staging.fdm.treesoflives.com',
  SENTRY_AUTH_TOKEN: 'e5b2ec73af4d499b96ef729eae435d7c2ab87878c1c14c6db271ce156c64f8e1',
  DOWNLINK_TRESHOLD: '0.2',
  HERE_API_KEY: '9x2CSrINfWbkkUmsALQbXFguPfVP4q6UPnn6DoqRko0',
  MAP_TILER_API_KEY: 'cvwn3Ud6pu4w6T357xFi',
  BING_API_KEY: 'AuUIY0hLOeAsnUUVA5RmwjaYWEKNIejk2lx6GyBRITYiQShyMgDHcRqk7CcV1iZw',
};
